var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "isDone": _vm.isDone,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "image": _vm.header.image,
      "debug": _vm.header.debug,
      "showFooter": false,
      "hasInstructions": true,
      "instructionPictures": _vm.instruction.pictures,
      "instructionText": _vm.instruction.text,
      "instructionTitle": _vm.instruction.title
    },
    on: {
      "next": _vm.next
    }
  }, [_vm.isLoading ? _c('v-sheet', {
    staticClass: "mb-2 py-n6 mt-2",
    attrs: {
      "rounded": "",
      "outlined": ""
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "article"
    }
  })], 1) : !_vm.combiDeal ? _c('v-sheet', {
    staticClass: "mb-2 py-n6 mt-2",
    attrs: {
      "rounded": "",
      "outlined": ""
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("report.thgProducts.noItemsTitle")))]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("report.thgProducts.noItemsSubtitle")) + " "), _c('a', {
    attrs: {
      "href": "mailto:info@mintfuture.de"
    }
  }, [_vm._v("info@mintfuture.de")])])], 1)], 1)], 1), _c('v-btn', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "color": "info",
      "small": ""
    },
    on: {
      "click": _vm.fetchPrices
    }
  }, [_vm._v(_vm._s(_vm.$t("report.thgProducts.noItemsBtn")))])], 1) : _c('div', [_c('v-card', {
    staticClass: "grey lighten-4",
    attrs: {
      "outlined": "",
      "rounded": ""
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.cardTitle))]), _vm._l(_vm.combiDeal.prices, function (price, idx) {
    return _c('v-list-item', {
      key: idx
    }, [_c('v-list-item-content', [price.title ? _c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(price.title)
      }
    }) : _vm._e(), price.subtitle ? _c('v-list-item-subtitle', {
      domProps: {
        "innerHTML": _vm._s(price.subtitle)
      }
    }) : _vm._e(), price.description ? _c('v-list-item-subtitle', {
      domProps: {
        "innerHTML": _vm._s(price.description)
      }
    }) : _vm._e(), price.hint ? _c('v-list-item-subtitle', {
      domProps: {
        "innerHTML": _vm._s(price.hint)
      }
    }) : _vm._e()], 1), _c('v-list-item-action', [_vm._v(" " + _vm._s(price.totalAmountAsString) + " ")])], 1);
  }), this.activePromotion && this.activePromotion.value && this.activePromotion.isApplicable ? _c('v-list-item', [_c('v-list-item-content', [!this.activePromotion.title ? _c('v-list-item-title', {
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.PromotionTypeEnum.".concat(this.activePromotion.type))) + " ")]) : _c('v-list-item-title', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(this.activePromotion.title)
    }
  })]), this.activePromotion.subtitle ? _c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(this.activePromotion.subtitle)
    }
  }) : _vm._e(), this.activePromotion.description ? _c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(this.activePromotion.description)
    }
  }) : _vm._e(), this.activePromotion.hint ? _c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(this.activePromotion.hint)
    }
  }) : _vm._e()], 1), _c('v-list-item-action', [_vm._v(" " + _vm._s(this.activePromotion.value.toLocaleString("de-DE", {
    style: "currency",
    currency: _vm.CurrencyEnum.EUR
  })) + " ")])], 1) : _vm._e(), _c('v-divider', {
    staticClass: "mx-4"
  }), _c('v-list-item', {
    staticClass: "font-weight-black"
  }, [_c('v-list-item-title', [_vm._v("Gesamtbetrag")]), _c('v-list-item-action', [_vm._v(" " + _vm._s(_vm.totalAmount.toLocaleString("de-DE", {
    style: "currency",
    currency: _vm.CurrencyEnum.EUR
  })) + " ")])], 1)], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }